module.exports = __webpack_public_path__ + "assets/020692191a36f8fafdd15e519b70f17b.mp3";